<template>
    <b-modal 
      ref="modal"
      :visible=visible
      :hide-footer="footer_hide" 
      :id="'modal-config_lamp'+this._uid"
      :title="$t('configura_lamp_modal.title')" 
      :ok-title="$t('configura_lamp_modal.ok_button')" 
      :cancel-title="$t('configura_lamp_modal.cancel_button')" 
      @ok="handleOk"
      :ok-disabled="!selectedFunction || (selectedFunction === 'switchable' && selectedGroups.length === 0) || selectedDimmer === null"
      @change="change"
      aria-describedby="modal-description"
      @shown="inizializzaStato"
       >
      <!-- @hidden="onModalHidden" -->
      <b-container>
        <p id="modal-description" class="sr-only">
            {{ $t('configura_lamp_modal.spiega_modal') }}
        </p>
        <b-row align-h="center">
          <b-col cols="12">
            <b-card
              border-variant="primary"
              header-bg-variant="light"
              header-text-variant="dark"
              class="mb-3"
            >
            <!-- :sub-title="$t('configura_lamp_modal.title')" -->
              <!-- Seleziona funzione -->
               <b-form-group :label="$t('configura_lamp_modal.select_function')" :label-for="$t('configura_lamp_modal.select_function')" label-class="font-weight-bold">
                <b-form-radio-group
                  id="function-select"
                  v-model="selectedFunction"
                  :options="functionOptions"
                  name="functions"
                  stacked
                  aria-describedby="function-help"
                />
                <small id="function-help" class="form-text text-muted sr-only">
                  {{ $t('configura_lamp_modal.select_function_help') }}
                </small>
              </b-form-group>
              <!-- Selezione dimmer -->
              <b-form-group v-if="(selectedFunction != 'not mantained') && (selectedFunction != null)" :label="$t('configura_lamp_modal.select_dimmer')" label-for="dimmer-selection" label-class="font-weight-bold">
                <multiselect
                  v-model="selectedDimmer"
                  :options="dimmerOptions"
                  placeholder="seleziona o cerca un dimmer"
                  label="text"
                  track-by="value"
                  :searchable="true"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :max-height="200"
                  :class="{'invalid': selectedDimmer === null}">
                </multiselect>
              <!-- Seleziona gruppi -->
              </b-form-group>
              <b-form-group v-if="(selectedFunction === 'switchable') && (selectedDimmer != null)" :label="$t('configura_lamp_modal.select_group')" label-class="font-weight-bold">
                <small id="group-help" class="form-text text-muted">
                  {{ $t('configura_lamp_modal.spiega_select')}}
                </small>
                <b-row>
                  <b-col cols="12" class="d-flex align-items-center">
                    <multiselect 
                      v-model="selectedGroups" 
                      :options="groupsOption"
                      placeholder="seleziona o cerca un gruppo"
                      label="text"
                      track-by="value"
                      :searchable="true"
                      :multiple="true"
                      :close-on-select="true"
                      :clear-on-select="false"
                      :max="4"
                      :max-height="200"
                      :class="{'invalid': selectedGroups.length === 0}"
                    >
                      <template slot="tag" slot-scope="props">
                          <!-- <span class="custom__tag"> -->
                            <span class="custom-tag badge badge-primary mr-1">
                              <span>{{ props.option.text }}</span>
                              <!-- <span class="custom__remove" -->
                              <span class="custom-remove" @click="props.remove(props.option)">x</span>
                          </span>
                      </template>
                      <template slot="maxElements">
                          {{ $t('configura_lamp_modal.max_elements') }}
                      </template>
                    </multiselect>
                  </b-col>
                  <!-- <b-col cols="6">
                    <b-form-select
                     :id="'group-${n}'"
                     v-model="selectedGroups[n-1]"
                     :options="filteredOptions(n-1)"
                     :state="isValid || selectedGroups[n-1] ? null : false"
                    />
                  </b-col> -->
                </b-row>

                <!-- <b-row v-for="n in 4" :key="n" class="mb-2">
                  
                  <b-col cols="6" class="d-flex align-items-center">
                    <label :for="'group-${n}'" class="ml-2">{{ $t('configura_lamp_modal.group') }} {{ n }}</label>
                  </b-col> 
                  
                  <b-col cols="6">
                    <b-form-select
                     :id="'group-${n}'"
                     v-model="selectedGroups[n-1]"
                     :options="filteredOptions(n-1)"
                     :state="isValid || selectedGroups[n-1] ? null : false"
                    />
                  </b-col>
                </b-row>  -->
                
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
      <!-- modal che avvisa che la configurazione di una lampada, attiva tutta la linea di appartenenza -->
      <b-modal
        id="warning-modal"
        ref="warningModal"
        v-model="showWarning"
        :title="$t('warning')"
        ok-only
        :ok-title="$t('configura_lamp_modal.understood')"
        header-bg-variant="warning"
        header-text-variant="dark"
        aria-labelledby="warning-modal-title"
        aria-describedby="warning-modal-desc"
        role="alertdialog"
        hide-header-close
      >
        <div style="font-size:medium">
          {{ $t('configura_lamp_modal.warning_msg')}}
        </div>
      </b-modal>


      <!-- Alert da utilizzare in caso di errore nell'inserimento dati nel form -->
      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="danger"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged">
        <p class="typo-label">{{ alertMessage }}</p>
      </b-alert>

    </b-modal>

</template>

<script>
import multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'


export default {
  name: 'LampConfig',
  components: { multiselect },
  model: {
    prop: "visible",
    event: "change"
  },
  props:
  {
    visible: {
      type: Boolean,
      default: false
    },
    sendAction: null,
    currentCent: null, //è l'oggetto Centrale
    currentLamp: null,
  },
  emits: ['hide', 'change'], //'hide', 
  data () {
    return {
      footer_hide:false,
      selectedFunction: null,
      selectedDimmer: null,
      functionOptions: [
          { text: this.$t('configura_lamp_modal.maintained'), value: 'mantained' }, //il backend si aspetta questa stringa sbagliata ('maintained' è corretto...)
          { text: this.$t('configura_lamp_modal.not_maintained'), value: 'not mantained' }, //il backend si aspetta questa stringa sbagliata ('not maintained' è corretto...)
          { text: this.$t('configura_lamp_modal.switchable'), value: 'switchable' }
        ],
      dismissSecs: 5,
      dismissCountDown: 0,
      alertMessage:"",
      dimmerOptions: Array.from({ length: 11 }, (_, i) => ({
        text: `${i * 10}%`,
        value: String(i * 10)
      })),
      selectedGroups: [],
      gorupsOption: [],
      showWarning: true
    }
  },

  methods: {
    //funzione di inizializzazione richiamata quando il modale viene mostrato (@shown)
    inizializzaStato() {
      console.log("inizializzaStato", { currentLamp: this.currentLamp, currentCent: this.currentCent });

      //preparo la variabile con i gruppi disponibili su questa centrale
      this.groupsOption = this.currentCent.groups.map((group) => ({
        text: `gruppo ${Number(group.groupId)}`,
        value: String(Number(group.groupId))
      }));

      //visualizzo il messaggio di avviso solo se la linea è disattiva
      // let ak = this.currentCent.find(ak => ak.index === this.currentLamp.ak_index);
      // let line = ak.lines.find(line => line.index === this.currentLamp.ak_line);
      // this.showWarning = line.deactivated;
      // const lineIsDeactivated = this.currentCent.ak.find(ak => ak.index === this.currentLamp.ak_index)
      //   ?.lines.find(line => line.index === this.currentLamp.ak_line)
      //   ?.deactivated === 'ON' ? true : false;
      // console.log("lineIsDeactivated: ", lineIsDeactivated);
      // this.showWarning = lineIsDeactivated;

      //visualizza un messaggio che avvisa che verrà attivata tutta la linea
      this.showWarning = true
      // Reset delle selezioni dei gruppi
      this.selectedFunction = this.functionOptions.find(func => func.value === this.currentLamp.device_function.toLowerCase()).value;
      this.selectedDimmer = this.dimmerOptions.find(dim => dim.value === String(Number(this.currentLamp.dimming) * 10));
      this.selectedGroups = [];
      if (this.selectedFunction === 'switchable') {       
        for (let i = 0; i < 4; i++) {
          if (this.currentLamp.groups[i]) {
            let grOption = this.groupsOption.find((option) => {
              return (option.value === this.currentLamp.groups[i]);
            });
            if (grOption != null) {              
              this.selectedGroups.push(grOption);
            }
          }
        }
      }
      console.log("inizializzaStato, selectedGroups: " + this.selectedGroups + ", selectedFunction: " + this.selectedFunction + ", selectedDimmer: " + this.selectedDimmer);
    },
    // filteredOptions(index) {
    //   // Filtra le opzioni per includere solo i gruppi presenti nella Centrale
    //   const selectedValues = this.selectedGroups.filter((_, i) => i !== index);
    //   return this.groupsOption.filter(option => !selectedValues.includes(option.value));
    // },
    //si attiva con l'evento 'change' ed emette verso il padre un evento 'change'
    change(visible)
    {
      console.log("change, visible: ", visible);
      this.selectedFunction = null;
      this.selectedDimmer = null;
      this.selectedGroups = [];
      this.$emit("change", visible);
    },
    //si attiva con l'evento 'hide' ed emette verso il padre un evento 'hide'
    hide()
    {
      console.log("hide, visible: ", this.visible);
      this.$emit("hide");
    },
    //restituisce EMERGENZA  o ILLUMINAZIONE 
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveParam();
    },
    saveParam() 
    { 
      var params ={};
      params.command = "configLuci";
      // params.cu_type = this.currentCent.split('#')[0];
      // params.cu_id = this.currentCent.split('#')[1];
      params.cu_type = this.currentCent.cu_type;
      params.cu_id = this.currentCent.cu_id;
      //params.lamp_index = ((parseInt(this.currentLamp.ak_index) - 1) * 132) + ((parseInt(this.currentLamp.ak_line) - 1) * 32) + (parseInt(this.currentLamp.idx));
      params.lamp_index = this.currentLamp.idx;
      params.function = this.selectedFunction;
      if (this.selectedDimmer !== null) {
        params.dimmer = this.selectedDimmer.value;
      }
      if (this.selectedFunction === 'switchable') {
        params.groups = this.selectedGroups.filter(g => g !== null).map(g => g.value.toString());
      }
      console.log("LampConfig, params: ", params);
      this.sendAction(params);

      // Hide the modal manually
      this.$nextTick(() => {
          this.$refs.modal.hide()
        })
    },       
  }
}
</script>

<style>

.multiselect.invalid {
  border: 2px solid red !important;
}

/* .multiselect.valid {
  border: 2px solid green !important;
} */


.custom-tag {
  font-size: 1rem;       /* aumenta la dimensione del testo */
  /* padding: 0.5em 0.75em; aumenta lo spazio interno */
  padding: 4px 8px;
  border-radius: 0.5rem; /* angoli più arrotondati */
  color: white;
  margin: 2px;
}
.custom-tag > span:first-child {
  margin-right: 8px;             /* spazio tra testo e X */
}

.custom-remove {
  color: black;                  /* X nera */
  font-weight: bold;
  cursor: pointer;
}
.custom-remove:hover {
  color: red;                    /* X rossa al passaggio del mouse */
}


/* .custom__tag {
  display: inline-flex;
  align-items: center;
  border: 1px solid #007bff; 
  border-radius: 8px;
  background-color: #e7f1ff;
  padding: 4px 8px;
  margin: 2px;
  font-family: sans-serif;
}

.custom__tag > span:first-child {
  margin-right: 8px; 
}

.custom__remove {
  color: black;
  font-weight: bold;
  cursor: pointer;
}
.custom__remove:hover {
  color: red; 
} */

</style>
